<template>
  <div class="invoice_row">
    <span class="invoices_cell" data-label="Date">{{ invoice.date }}</span>
    <span class="invoices_cell invoice_draft" data-label="Draft" :title="invoice.draftName">{{ invoice.draftName }}</span>
    <span class="invoices_cell invoice_number" data-label="Invoice #">
      <a
        v-if="invoice.pdfUrl"
        class="invoice_number_value"
        :href="invoice.pdfUrl"
        target="_blank"
        rel="noopener"
        title="Download invoice"
      >
        <span class="invoice_number_link">{{ invoice.number }}</span>
        <span class="download_icon invoice_pdf_inline" />
      </a>
      <span v-else class="invoice_number_value">
        <span class="invoice_number_link">{{ invoice.number }}</span>
        <span
          v-if="generating"
          class="download_icon download_icon--spinner invoice_pdf_inline"
        />
        <button
          v-else-if="invoice.canGeneratePdf"
          class="download_icon download_icon--generate invoice_pdf_inline"
          title="Generate invoice PDF"
          @click="$emit('generate-pdf')"
        />
      </span>
    </span>
    <span class="invoices_cell" data-label="Invoice Type">{{ invoice.invoiceType || '-' }}</span>
    <span class="invoices_cell invoice_payment_type" data-label="Payment Type">{{ invoice.paymentType || '-' }}</span>
    <span class="invoices_cell invoice_paid_amount" data-label="Paid Amount">{{ invoice.isOutgoing ? invoice.total : (invoice.paymentType ? invoice.paidAmount : '-') }}</span>
    <span class="invoices_cell invoice_status_cell" data-label="Status">{{ invoice.paymentStatus === 'paid' ? 'Paid' : 'Unpaid' }}</span>
    <span class="invoices_cell invoice_pay_cell">
      <button
        v-if="invoice.needToPay"
        class="invoice_pay_button pay-button btn btn-primary px-lg-3"
        @click="$emit('pay', invoice)"
      >
        Pay {{ invoice.total }}
      </button>
    </span>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'InvoiceRow',
  props: {
    invoice: { type: Object, required: true },
    generating: { type: Boolean, default: false }
  },
  emits: ['pay', 'generate-pdf']
})
</script>



// WEBPACK FOOTER //
// src/components/Invoices/InvoiceRow.vue